import { reject, isEmpty } from "ramda";

import Vue from "vue";
import Vuex from "vuex";
import { getField, updateField } from "vuex-map-fields";

import api from "../common/config/apiAxiosInstance";

Vue.use(Vuex);

/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */

// initial state
const state = {
  events: [],
  courses: [],
  loadingError: false,
  loadingErrorMessage: "",
  beforeInitialFetch: true,
  withCourses: window.CourseList.withCourses
};

// getters
const getters = {
  getField,
  withCourses: state => state.withCourses,
  allEvents() {
    if (state.withCourses) {
      return state.events.map(item => {
        let course = state.courses.find(courseItem => {
          return courseItem.course_id === item.course_id;
        });

        item.course = course;

        return item;
      });
    }
    return state.events;
  }
};

// actions
const actions = {
  loadEvents({ commit }) {
    api
      .get(`!/courses-list/events-collection/${window.CourseList.courseId}`, {})
      .then(response => {
        commit("setEventsData", response.data);
        commit("setBeforeInitialFetch", false);
      })
      .catch(() => {
        commit("setError", "Something went wrong");
      });
  },
  loadCourses({ commit }) {
    api
      .get("!/courses-list/courses-collection/")
      .then(response => {
        commit("setCoursesData", response.data);
      })
      .catch(() => {
        commit("setError", "Something went wrong");
      });
  }
};

// mutations
const mutations = {
  updateField,
  setBeforeInitialFetch(state, value) {
    state.beforeInitialFetch = value;
  },
  setEventsData(state, payload) {
    state.events = payload;
  },
  setCoursesData(state, payload) {
    state.courses = payload;
  },
  setError(state, errorMessage) {
    state.loadingError = true;
    state.loadingErrorMessage = errorMessage;
  }
};

const store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations
});

export default store;
